<template>
    <v-container
        class="pa-0"
        fluid
    >
        <v-layout>
            <v-subheader>{{ title }}</v-subheader>
        </v-layout>
        <v-layout
            align-center
            fill-height
            row
            wrap
        >
            <v-flex xs12 md3 lg3 class="pl-2">
                <v-switch 
                 label="Sem interação" v-model="excludeInteractions" 
                @change="$emit('update:excludeInteractions', $event || false)"
                hide-details
            ></v-switch>
            </v-flex>
            <v-flex
                xs12
                md3
                lg3
                class="pa-2"
            >
                <v-text-field
                :disabled="excludeInteractions !== undefined && !excludeInteractions"
                :value="minInteractionDays" 
                @input="$emit('update:minInteractionDays', $event)"
                hide-details 
                type="number"
                min="0"
                box
                label="De [x] dias da última interação">
                    <template v-slot:prepend-inner>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    class="help-icon"
                                    color="grey"
                                    v-on="on"
                                >
                                    help
                                </v-icon>
                            </template>
                            <p>
                                Quantidade mínima de dias de interação
                            </p>
                        </v-tooltip>
                    </template>
                </v-text-field>                
            </v-flex>
            <v-flex
                xs12
                md3
                lg3
                class="pa-2"
            >
                <v-text-field
                :disabled="excludeInteractions !== undefined && !excludeInteractions"
                :value="maxInteractionDays"
                @input="$emit('update:maxInteractionDays', $event)"
                hide-details 
                type="number" 
                min="0"
                box 
                label="Até [x] dias da última interação">
                    <template v-slot:prepend-inner>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    class="help-icon"
                                    color="grey"
                                    v-on="on"
                                >
                                    help
                                </v-icon>
                            </template>
                            <p>
                                Quantidade máxima de dias de interação
                            </p>
                        </v-tooltip>
                    </template>
                </v-text-field>
            </v-flex>
            <v-flex shrink>
                <v-tooltip
                    bottom
                >
                    <template
                        v-slot:activator="{ on }"
                    >
                        <v-btn
                            icon
                            v-on="on"
                            @click="$emit('removeInteraction', name)"
                        >
                            <v-icon
                                color="grey"
                            >
                                delete
                            </v-icon>
                        </v-btn>
                    </template>

                    <span>Remover interação</span>
                </v-tooltip>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    props: [
        'excludeInteractions',
        'maxInteractionDays',
        'minInteractionDays',
        'name',
        'title',
    ],
};
</script>

<style scoped>
.help-icon {
    cursor: help;
    font-size: 20px;
    margin-top: 2px;
}
</style>
